import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Icon, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import IconTooltipButton from '../../../../../button/IconTooltipButton';
import DialogGrowthGoals from './DialogGrowthGoals';

const GrowthGoals = ({ isLoading, top = 250 }) => {
  const [modal, setModal] = useState(null);
  const growthGoals = useSelector((state) => state?.class?.unitOfLearning.growthGoals || []);

  return (
    <>
      <div
        className={['bg-background bottom-0 absolute z-20 overflow-auto border-t border-muted']}
        style={{ top: `calc(${top}px + 2rem)`, width: 'calc(200px - 0.5rem)' }}
      >
        <div className='pt-1 pb-2 pl-1 pr-2 flex flex-col gap-2'>
          {isLoading ? (
            Array.from({ length: 3 }).map((_, i) => (
              <Skeleton variant='rectangular' className='rounded' key={`log-loading-${i}`} height={100} />
            ))
          ) : growthGoals?.length > 0 ? (
            <div className='flex flex-col gap-1 w-full pt-2'>
              {growthGoals.map((example) => (
                <div key={`item-growth-goals-${example._id}`} className='rounded bg-loading '>
                  <div className='flex gap-2 px-2 py-2 items-start'>
                    <span className=' '>
                      <FontAwesomeIcon
                        icon='question'
                        className='text-sm p-1 text-muted size-4 opacity-50 bg-muted-foreground flex items-center justify-center rounded-full'
                      />
                    </span>
                    <Typography variant='inherit' className='text-muted-foreground opacity-90'>
                      {example.question}
                    </Typography>
                  </div>
                  <div className='flex gap-2 justify-end px-2 pb-2'>
                    <IconTooltipButton
                      title='Reply to question'
                      icon='paper-plane-top'
                      classNameIcon='text-muted-foreground opacity-50 '
                      onClick={() => setModal({
                        questionId: example._id,
                        ...example
                      })}
                      style={{
                        width: 24,
                        height: 24,
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <Typography className='text-muted-foreground opacity-50 text-center pt-2'>
              You don't have any question yet
            </Typography>
          )}
        </div>
      </div>
      {modal && <DialogGrowthGoals open={!!modal} onClose={() => setModal(null)} formData={modal} />}
    </>
  );
};

export default GrowthGoals;
